import Grid from '@material-ui/core/Grid';
import * as moment from 'moment';
import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {POLICY_TYPE, STATUS, URL} from '../../Config/appConfig';
import {CoverNote, Option} from '../../Config/dataModel';
import util from '../../Util/util';
import RecordsDayLeftView from './RecordsDayLeftView';

const warnVoidedIcon = require('../../resource/img/warn-voided.svg');
const warnArchivedIcon = require('../../resource/img/warn-archived.svg');

interface RecordsTableViewCellProps {
    refNo: string,
    valid: boolean,
    arrowDirection: 'LEFT' | 'RIGHT',
    dayLeft: number,
    status: string,
    issueNumber: string,
    company: string,
    license: string,
    endDate: string,
    policyType: string,
    searchResult?: CoverNote[],
    identity?: Option,
    identityNo?: string,
    checksum?: string
}

class RecordsTableViewCell extends React.Component <RouteComponentProps & RecordsTableViewCellProps, {}> {
    public constructor(props: RecordsTableViewCellProps) {
        super(props);
        this.clickCell = this.clickCell.bind(this);
    }

    public clickCell() {
        let type = '';
        switch (moment(this.props.endDate).isSameOrBefore(moment()) ? POLICY_TYPE.ARCHIVED : this.props.policyType) {
            case POLICY_TYPE.COVER_NOTE:
                type = URL.COVER_NOTE;
                break;
            case POLICY_TYPE.POLICY:
                type = URL.POLICY;
                break;
            case POLICY_TYPE.ARCHIVED:
                type = `${this.props.policyType === POLICY_TYPE.COVER_NOTE ? URL.VIEW_ARCHIVED_COVER_NOTE.split('/:id')[0] : URL.VIEW_ARCHIVED_POLICY.split('/:id')[0]}`;
                break;
            default:
                break;
        }
        const location = `${type}/${this.props.refNo}`;
        if (this.props.searchResult) {
            this.props.history.push({
                pathname: location,
                state: {
                    searchResult: this.props.searchResult,
                    identity: this.props.identity,
                    identityNo: this.props.identityNo,
                    checksum: this.props.checksum
                }
            });
        }
        else this.props.history.push(location);
    }

    public getStatusCell() {
        if (!this.props.valid || this.props.dayLeft < 1) {
            return (
                <div className="recordsDayLeftView recordsTableViewCellVoid">
                    <img src={this.props.valid ? warnArchivedIcon : warnVoidedIcon}/>
                    <div className={`${this.props.valid ? '' : 'cmErrorText '}recordsTableViewCellVoidLabel`}>{this.props.valid ? STATUS.EXPIRED : STATUS.VOIDED}</div>
                </div>
            );
        }
        else {
            return (
                <RecordsDayLeftView
                    dayLeft={this.props.dayLeft}
                    status={this.props.status}
                    arrowDirection={this.props.arrowDirection}/>
            );
        }
    }

    public render() {
        return (
            <div className="cmTableViewCell cmText cmClickable" onClick={this.clickCell}>
                <Grid className="cmTableViewCol" item xs={2}>
                    <div className="cmTableViewCellData">{this.getStatusCell()}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={2}>
                    <div className={`cmTableViewCellData${this.props.valid ? "" : " cmErrorText"}`}>{this.props.issueNumber}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={4}>
                    <div className={`cmTableViewCellData${this.props.valid ? "" : " cmErrorText"}`}>{this.props.company}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={2}>
                    <div className={`cmTableViewCellData${this.props.valid ? "" : " cmErrorText"}`}>{util.getLicense(this.props.license)}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={2}>
                    <div className={`cmTableViewCellData${this.props.valid ? "" : " cmErrorText"}`}>{util.getFormattedDate(this.props.endDate)}</div>
                </Grid>
            </div>
        );
    }
}

export default withRouter(RecordsTableViewCell);



// WEBPACK FOOTER //
// ./src/Components/Records/RecordsTableViewCell.tsx